var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "popup-table popup-table--full-width",
      attrs: { id: "accumulated_precp" }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "popup-table__wrapper",
          staticStyle: { "min-height": "0" }
        },
        [
          _c("div", { staticClass: "popup-table__container" }, [
            _c("div", { staticClass: "popup-table__container-title" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-space-between align-center" },
                [
                  _c("h1", [_vm._v("自選時段累積雨量")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "back-station-title__btn",
                          attrs: { color: "white", icon: "" },
                          on: {
                            click: function($event) {
                              _vm.is_minimize = !_vm.is_minimize
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.is_minimize
                                    ? "mdi-window-maximize"
                                    : "mdi-window-minimize"
                                ) +
                                "\n                            "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "back-station-title__btn",
                          attrs: { color: "white", icon: "" },
                          on: {
                            click: function($event) {
                              _vm.is_table_expand = !_vm.is_table_expand
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.is_table_expand
                                    ? "mdi-chevron-down"
                                    : "mdi-chevron-up"
                                ) +
                                "\n                            "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "back-station-title__btn",
                          attrs: { color: "white", icon: "" },
                          on: { click: _vm.close_accu_precp }
                        },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v(
                              "\n                                icon-close\n                            "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "control-options",
              class: { minimize: _vm.is_minimize, custom: _vm.is_custom }
            },
            [
              _c("div", { staticClass: "control-options__setting flex-gap" }, [
                _c("div", { staticClass: "control-options__time-setting" }, [
                  _c(
                    "div",
                    { staticClass: "control-options__item" },
                    [
                      _c(
                        "span",
                        { staticClass: "control-options__item-hint" },
                        [_vm._v("起始日期")]
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "control-options__item-select",
                        attrs: {
                          items: _vm.dates,
                          dense: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.selected_start_date,
                          callback: function($$v) {
                            _vm.selected_start_date = $$v
                          },
                          expression: "selected_start_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "control-options__item" },
                    [
                      _c(
                        "span",
                        { staticClass: "control-options__item-hint" },
                        [_vm._v("起始時間")]
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.start_hours,
                          dense: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.selected_start_hour,
                          callback: function($$v) {
                            _vm.selected_start_hour = $$v
                          },
                          expression: "selected_start_hour"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "control-options__dash" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "control-options__item" },
                    [
                      _c(
                        "span",
                        { staticClass: "control-options__item-hint" },
                        [_vm._v("結束日期")]
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.dates,
                          "hide-details": "",
                          dense: ""
                        },
                        model: {
                          value: _vm.selected_end_date,
                          callback: function($$v) {
                            _vm.selected_end_date = $$v
                          },
                          expression: "selected_end_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "control-options__item" },
                    [
                      _c(
                        "span",
                        { staticClass: "control-options__item-hint" },
                        [_vm._v("結束時間")]
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.end_hours,
                          "hide-details": "",
                          dense: ""
                        },
                        model: {
                          value: _vm.selected_end_hour,
                          callback: function($$v) {
                            _vm.selected_end_hour = $$v
                          },
                          expression: "selected_end_hour"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.is_custom
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "control-options__item control-options__item--no-hint"
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              "background-color": "lightcoral",
                              items: _vm.counties_list,
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.county_selected,
                              callback: function($$v) {
                                _vm.county_selected = $$v
                              },
                              expression: "county_selected"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.is_custom
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "control-options__item control-options__item--no-hint"
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              "background-color": "lightcoral",
                              items: _vm.towns_list,
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.town_selected,
                              callback: function($$v) {
                                _vm.town_selected = $$v
                              },
                              expression: "town_selected"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "control-options__item control-options__time",
                      class: {
                        "control-options__time--active":
                          _vm.has_time_setting_error
                      }
                    },
                    [
                      _c("span", [_vm._v("結束時間")]),
                      _vm._v(" "),
                      _c("span", [_vm._v("小於")]),
                      _vm._v(" "),
                      _c("span", [_vm._v("起始時間")])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.is_custom
                  ? _c(
                      "div",
                      { staticClass: "control-options__custom flex-gap" },
                      [
                        _c(
                          "div",
                          { staticClass: "control-options__select flex-gap" },
                          [
                            _c(
                              "v-radio-group",
                              {
                                attrs: { "hide-details": "" },
                                model: {
                                  value: _vm.current_select,
                                  callback: function($$v) {
                                    _vm.current_select = $$v
                                  },
                                  expression: "current_select"
                                }
                              },
                              [_c("v-radio", { attrs: { value: "tag" } })],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "control-options__item control-options__item--no-hint"
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    "background-color": "lightcoral",
                                    items: _vm.tag_list_rainstation,
                                    "hide-details": "",
                                    "return-object": "",
                                    "item-text": "tag_name",
                                    "item-value": "tag_id"
                                  },
                                  model: {
                                    value: _vm.selected_tag,
                                    callback: function($$v) {
                                      _vm.selected_tag = $$v
                                    },
                                    expression: "selected_tag"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "control-options__select flex-gap" },
                          [
                            _c(
                              "v-radio-group",
                              {
                                attrs: { "hide-details": "" },
                                model: {
                                  value: _vm.current_select,
                                  callback: function($$v) {
                                    _vm.current_select = $$v
                                  },
                                  expression: "current_select"
                                }
                              },
                              [_c("v-radio", { attrs: { value: "county" } })],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "control-options__item control-options__item--no-hint"
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    "background-color": "lightcoral",
                                    items: _vm.counties_list,
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.county_selected,
                                    callback: function($$v) {
                                      _vm.county_selected = $$v
                                    },
                                    expression: "county_selected"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "control-options__item control-options__item--no-hint"
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    "background-color": "lightcoral",
                                    items: _vm.towns_list,
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.town_selected,
                                    callback: function($$v) {
                                      _vm.town_selected = $$v
                                    },
                                    expression: "town_selected"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "control-options__btn-wrapper" }, [
                _c(
                  "button",
                  {
                    staticClass: "control-options__btn",
                    class: {
                      "control-options__btn--disabled":
                        _vm.has_time_setting_error
                    },
                    on: { click: _vm.get_accu_precp_data }
                  },
                  [_vm._v("\n                    查詢\n                ")]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "accumulated-precp__table-container",
              class: { expand: _vm.is_table_expand, minimize: _vm.is_minimize }
            },
            [
              _vm.show_table
                ? _c("QpeDatatable", {
                    staticClass: "accumulated-precp__table-content",
                    attrs: {
                      data: _vm.table_data,
                      headers: _vm.header,
                      show_datetime: false,
                      show_search_bar: false,
                      show_footer: true,
                      header_background_color: "#e8ecf7",
                      header_text_color: "black",
                      table_page_component_id: "accumulated_precp",
                      show_description_dialog_btn: false,
                      show_download_pdf_btn: true,
                      table_text_for_download_pdf: "自選時段累積雨量"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }